/** Fired after team praise is saved so the dashboard banner can refetch immediately. */
export const TEAM_PRAISE_UPDATED_EVENT = "tcs:team-praise-updated";
